export default {
  storageManager: {
    type: 'google-firebase',
    autosave: false,
    autoload: true,
    id: 'novti-recipe-', // Prefix identifier that will be used on parameters
  },
}
